import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppRoutes } from "./app-routes";
import { AuthCheck } from "./components/auth-check.component";
import { SidebarMui } from "./components/sidebar/sidebarMui.component";

import { ContextProviders } from "./components/context/context-providers";
import { Stack } from "@mui/material";

function App() {
  return (
    <BrowserRouter>
      <ContextProviders>
        <Routes>
          <Route
            path="/*"
            element={
              <AuthCheck>
                <Stack direction="row" spacing={2} sx={{ height: "100vh" }}>
                  <SidebarMui />
                  <AppRoutes />
                </Stack>
              </AuthCheck>
            }
          />
        </Routes>
      </ContextProviders>
    </BrowserRouter>
  );
}

export default App;
